import { Database } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { databasesWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  databasesWeb,
  {
    DatabasesPage: () => import('./DatabasesPage'),
    DatabaseAttachmentPicker: () => import('./DatabaseAttachmentPicker'),
    DatabaseAttachmentSummary: () => import('./DatabaseAttachmentSummary'),
  },
  {
    icons: { Database },
  },
);
